<template>
  <base-page-template
    component-name="TradeResultShow">

    <template #toolbar-items>
      <v-toolbar-title class="with-divider">
        取引データ一覧(契約単位)
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
          color="primary"
          class="ml-3 px-4"
          @click="downloadCertificate">
        <v-icon>mdi-certificate-outline</v-icon>
        <span class="ml-2">証明書発行</span>
      </v-btn>
    </template>

    <trade-contract-info
        :tradeContract="tradeContractView"
        :companion="tradeContractView.companions"
        readonly>
      <template #append>
        <data-profile-info
            :data-profile-view="dataProfile"
            class="mt-3">
          <template #pull-request-parameter>
            <span style="display: none;"></span>
          </template>
        </data-profile-info>
      </template>
    </trade-contract-info>

    <tab-item-template>
      <div style="position: relative;">
        <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="15"
            class="py-3">
        </v-pagination>
        <message-table
          :messages="messages"
          :tradeContractId="tradeContractId">
        </message-table>
        <v-pagination
            v-model="page"
            :length="pageCount"
            :total-visible="15"
            class="py-3">
        </v-pagination>
        <v-overlay
            :value="loading"
            z-index="3"
            absolute>
          <v-progress-circular
              indeterminate
              size="64">
          </v-progress-circular>
        </v-overlay>
      </div>
    </tab-item-template>
  </base-page-template>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex";
import PathInfoMixin from "@/router/PathInfoMixin";
import IoablePageMixin from "@/router/IoablePageMixin";
import BasePageTemplate from "@/components/templates/BasePageTemplate.vue";
import TabItemTemplate from "@/components/templates/TabItemTemplate.vue";
import TradeContractInfo from "@/components/organisms/TradeContractInfo.vue";
import MessageTable from "@/components/pages/contract/TradeResultShow/MessageTable.vue";
import {createTradeContractView} from "@/components/pages/contract/TradeContract/TradeContractView";
import DataProfileInfo from "@/components/organisms/DataProfileInfo.vue";
import DataProfileSource from "@/components/organisms/DataProfileSource";
import FileUtils from "@/utils/FileUtils";
import {DateTime} from "luxon";

export default {
  name: 'TradeResultShow',
  components: {
    DataProfileInfo,
    BasePageTemplate,
    TabItemTemplate,
    TradeContractInfo,
    MessageTable
  },
  mixins: [
    PathInfoMixin,
    IoablePageMixin,
    FileUtils,
    DataProfileSource,
  ],
  props: {
    tradeContractId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dataProfile: {},
      page: 1,
      pageCount: 0,
      perPage: 10,
      loading: true,
    };
  },
  computed: {
    ...mapState('hcs/tradeContract', ['tradeContract']),
    ...mapState('hcs/message', ['messages']),
    ...mapGetters({
      hcsClient: 'hcs/client',
    }),
    tradeContractView() {
      return createTradeContractView(this.tradeContract, this.$store);
    }
  },
  methods: {
    ...mapMutations({
      showSnackbar: 'showSnackbar'
    }),
    load() {
      return Promise.all([
        (async _ => {
          try {
            this.loading = true;
            const result = await this.$store.dispatch('hcs/message/findList', {
              q: { tradeContractIdEq: this.tradeContractId },
              page: this.page,
              perPage: this.perPage,
            });
            this.page = result.page;
            this.pageCount = Math.ceil(result.total / result.perPage);
          } finally {
            this.loading = false;
          }
        })(),
        (async () => {
          await this.$store.dispatch('hcs/tradeContract/find', this.tradeContractId);
          this.dataProfile = await this.loadDataProfile(this.tradeContractView.selfDataProfileId);
        })()
      ])
    },
    async downloadCertificate() {
      this.showSnackbar({
        message: `取引データ履歴証明書を発行しています...`,
        timeout: false,
        loading: true
      });

      try {
        const today = DateTime.now().toFormat('yyyyMMdd');
        const tc = this.tradeContractView;
        const {data: blob} = await this.hcsClient.get(`/trade_contracts/${this.tradeContractId}/certificate.pdf`, {
          responseType: 'blob',
          headers: {
            "Accept": "application/pdf"
          }
        });
        this.showSnackbar({
          message: `取引データ履歴証明書が発行されました`
        });
        this.downloadFile(blob, `取引データ履歴証明書_${today}_${tc.id}_${tc.name}.pdf`);
      } catch (e) {
        console.error(e);
        this.showSnackbar({
          color: 'failed',
          message: `取引データ履歴証明書の発行に失敗しました`
        });
      }
    }
  },
  watch: {
    page: {
      handler() {
        this.load();
      }
    },
  }
}
</script>
